import { NavigateFunction } from "react-router-dom";

/**
 * Navigate to the artifact viewer page
 * @param navigate - The navigate function from react-router-dom useNavigate hook
 * @param interactionId - The interaction ID to view
 */
export const navigateToViewer = (
  navigate: NavigateFunction,
  interactionId: string
): void => {
  navigate(`/viewer?interaction_id=${interactionId}`);
};

export const updateUrlParams = (params: Record<string, string | null>): void => {
  const url = new URL(window.location.href);

  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  });

  window.history.replaceState({}, "", url.toString());
};

export default navigateToViewer;
